import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { requestExamStatusChange, getExamList } from "@/api/exam";
let Examination = class Examination extends Vue {
    constructor() {
        super(...arguments);
        this.selected = -1;
        this.search_content = '';
        this.examListSearch = '';
        this.total = 0;
        this.page_size = 15;
        this.examListPageIndex = 1;
        this.examLists = [];
        this.isLoading = true;
    }
    mounted() {
        const search = this.$route.query.search || '';
        this.examListSearch = search;
        this.search_content = search;
        this.examListPageIndex = Number(this.$route.query.page) || 1;
        this.loadExamLists();
    }
    gotoQuestionBank() {
        this.$router.push({ name: 'Question' });
    }
    goToEdit(exam) {
        this.$router.push({
            name: 'ExamEdit',
            query: {
                type: 'edit',
                exam_id: exam.id,
                state: exam.state
            }
        });
    }
    goToAppraiseList(exam) {
        this.$router.push({
            name: 'Appraise',
            query: {
                exam_id: exam.id,
                exam_name: exam.name
            }
        });
    }
    createExam() {
        localStorage.removeItem("exam_end_time");
        this.$router.push({
            name: 'ExamEdit',
            query: {
                type: 'add'
            }
        });
    }
    search() {
        this.examListPageIndex = 1;
        this.examListSearch = this.search_content;
        this.loadExamLists(true);
    }
    option(mode, exam) {
        var n = this;
        switch (mode) {
            case "publish":
                this.changeExamStatus(exam.id, 1);
                break;
            case "stop":
                this.$confirm('状态设置为“停止”后，学员将不能参与该考试', {
                    type: 'error',
                    title: '提示',
                    confirmButtonText: '确认',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.changeExamStatus(exam.id, 3);
                });
                break;
            default:
                break;
        }
    }
    changePage(pageIndex) {
        this.examListPageIndex = pageIndex;
        this.loadExamLists();
    }
    sizeChange(pageSize) {
        this.page_size = pageSize;
        this.loadExamLists();
    }
    async loadExamLists(disableLoading) {
        if (disableLoading) {
            this.isLoading = true;
        }
        try {
            const res = await getExamList({
                content: this.examListSearch || void 0,
                examStatus: this.selected !== -1 ? this.selected : void 0,
                pageNo: this.examListPageIndex,
                pageSize: this.page_size,
            });
            const data = res.data.data;
            data.list.forEach(item => {
                item.courseList = item.courseNames ? item.courseNames.split(',') : [];
            });
            this.examLists = data.list;
            this.total = Number(data.total);
            // this.eexam_switch = n.data.eexam_switch
        }
        catch (_) { }
        finally {
            this.isLoading = false;
        }
    }
    async changeExamStatus(id, status) {
        let text = status === 1 ? '发布' : status === 3 ? '停用' : '-';
        try {
            await requestExamStatusChange(id, status);
            this.$message.success(`${text}成功`);
            this.loadExamLists(true);
        }
        catch (error) {
            // this.$message.error(`${text}失败`)
        }
    }
};
Examination = tslib_1.__decorate([
    Component({
        name: 'Examination',
    })
], Examination);
export default Examination;
